const margin = 8;
const headerbarHeight = 88;
const subHeaderHeight = 120;
const breadCrumbHeight = 32;
const appDrawerWidth = 280;
const appDrawerCollapsedWidth = 78;
const appDrawerItemHeight = 45;
const pageDrawerWidth = 230;
const pageDrawerWidthSmall = 150;
const minimumPageWidth = 1000;
const minimumPageHeight = 1200;
const homeGridHeight = 400;
const baseWidth = 1440;

export const dimensions = {
  headerbarHeight: headerbarHeight,
  subHeaderHeight: subHeaderHeight,
  breadCrumbHeight: breadCrumbHeight,
  totalTopbarHeight: headerbarHeight + subHeaderHeight + margin * 2,
  pageDrawerWidth: pageDrawerWidth,
  pageDrawerWidthSmall: pageDrawerWidthSmall,
  appDrawerWidth: appDrawerWidth,
  totalAppDrawerWidth: appDrawerWidth,
  appDrawerCollapsedWidth: appDrawerCollapsedWidth,
  totalAppDrawerWithPageDrawer: appDrawerWidth + pageDrawerWidth + margin * 3,
  totalAppDrawerCollapsedWidthWithPageDrawer: appDrawerCollapsedWidth + pageDrawerWidth + margin * 3,
  appDrawerItemHeight: appDrawerItemHeight,
  margin: margin,
  heightAppBar: headerbarHeight,
  minimumPageWidth: minimumPageWidth,
  minimumPageHeight: minimumPageHeight,
  homeGridHeight: homeGridHeight,
  baseWidth: baseWidth,
};

export const getDimensions = () => dimensions;
